import React from "react";
import { useLocation } from "react-router-dom";
export default function SiteFooter() {
  const { pathname } = useLocation();
  const hashPrefix = pathname === '/' ? '' : '/';
  return (
    <footer>
      <div className="footer-one-wrapper w-full pt-[130px]">
        <div className="mx-auto theme-container">
          <div className="w-full">
            {/* <div className="top-bar w-full flex md:flex-row md:justify-between items-center flex-col space-y-10 md:space-y-0 md:mb-[80px] mb-10">
              <div>
                <img src={require("../../../assets/images/logo.png")} alt="" />
              </div>
              <ul className="flex flex-wrap gap-5 md:gap-14 md:items-center">
                <li className="font-semibold text-18 hover:text-purple common-transition text-paragraph cursor-pointer">
                  <a href="https://www.facebook.com/Informulate/" className="flex items-center gap-2 no-underline hover:text-purple">
                    <i className="fa-brands fa-facebook text-purple"></i>
                    Facebook
                  </a>
                </li>
                <li className="font-semibold text-18 hover:text-purple common-transition text-paragraph cursor-pointer">
                  <a href="https://mobile.twitter.com/informulate?lang=en" className="flex items-center gap-2 no-underline hover:text-purple">
                    <i className="fa-brands fa-twitter text-purple"></i>
                    Twitter
                  </a>
                </li>
                <li className="font-semibold text-18 hover:text-purple common-transition text-paragraph cursor-pointer">
                  <a href="https://www.youtube.com/channel/UCZpg4EfBwVG2JjngH84nlRA" className="flex items-center gap-2 no-underline hover:text-purple">
                    <i className="fa-brands fa-youtube text-purple"></i>
                    Youtube
                  </a>
                </li>
                <li className="font-semibold text-18 hover:text-purple common-transition text-paragraph cursor-pointer">
                  <a href="https://www.linkedin.com/company/informulate-llc/" className="flex items-center gap-2 no-underline hover:text-purple">
                    <i className="fa-brands fa-linkedin text-purple"></i>
                    LinkedIn
                  </a>
                </li>
              </ul>
            </div> */}
            <div className="w-full py-[80px] border-t border-[e7e3fa]">
              <div className="container mx-auto px-4">
                <div className="grid grid-cols-2 md:grid-cols-3 lg:flex lg:justify-between gap-8 md:gap-10">
                  {/* Quick Contact */}
                  <div className="col-span-2 md:col-span-1">
                    <h3 className="text-xl font-semibold mb-6">Quick Contact</h3>
                    <div className="font-medium text-paragraph space-y-4">
                      <div className="flex items-center gap-3">
                        <i className="fa-solid fa-phone text-purple" aria-hidden="true"></i>
                        <a 
                          href="tel:+14072843646" 
                          className="hover:text-purple transition-colors"
                          aria-label="Call us at 1-407-284-3646"
                        >
                          1-407-284-3646
                        </a>
                      </div>
                      <div className="flex items-center gap-3">
                        <i className="fa-solid fa-envelope text-purple" aria-hidden="true"></i>
                        <a 
                          href="mailto:hello@informulate.ai"
                          className="hover:text-purple transition-colors"
                          aria-label="Email us at hello@informulate.ai"
                        >
                          hello@informulate.ai
                        </a>
                      </div>
                      <div className="flex items-center gap-3">
                        <i className="fa-solid fa-location-dot text-purple"></i>
                        <span>Orlando, FL</span>
                      </div>
                    </div>
                  </div>
                  {/* <div className="xl:col-span-2 col-span-1">
                    <div className="w-full">
                      <p className="text-main-black text-18 font-semibold mb-[30px]">
                        Our Solutions
                      </p>
                      <ul className="flex flex-col space-y-2.5">
                        <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                          <Link to="/services">Digital Transformation</Link>
                        </li>
                        <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                          <Link to="/services">Product Development</Link>
                        </li>
                        <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                          <Link to="/services">Team Enrichment</Link>
                        </li>
                        <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                          <Link to="/services">Business Intelligence</Link>
                        </li>
                        <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                          <Link to="/services">Process Automation</Link>
                        </li>
                        <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                          <Link to="/services">AI/LLM Consulting</Link>
                        </li>
                     </ul>
                    </div>
                  </div> */}
                  {/* Useful Links */}
                  <div className="col-span-1 md:col-span-1">
                    <h3 className="text-xl font-semibold mb-6">Useful Links</h3>
                    <ul className="flex flex-col space-y-2.5">
                      <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                        <a href="https://informulate.com/frameworks-and-methodologies/" target="_blank" rel="noopener noreferrer">Approach</a>
                      </li>
                      <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                       <a href="https://informulate.com/in-the-news/" target="_blank" rel="noopener noreferrer">Media/In The News</a>
                      </li>
                      <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                        <a href="https://informulate.com/2m2x/" target="_blank" rel="noopener noreferrer">2m2x Videos</a>
                      </li>
                      <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                        <a target="_blank" rel="noopener noreferrer" href="https://informulate.com/solutions-and-assessments/">Solutions and Assessments</a>
                      </li>
                      <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                        <a href={`${hashPrefix}#contact`}>Contact Us</a>
                      </li>
                    </ul>
                 </div>
                  {/* Company */}
                  <div className="col-span-1 md:col-span-1">
                    <h3 className="text-xl font-semibold mb-6">Website Links</h3>
                    <ul className="flex flex-col space-y-2.5">
                      <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                        <a href={`${hashPrefix}#about`}>About us</a>
                      </li>
                      <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                        <a href={`${hashPrefix}#services`}>Services</a>
                      </li>
                      <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                        <a href={`${hashPrefix}#testimonial`}>Testimonials</a>
                      </li>
                      <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                        <a href={`${hashPrefix}#pricing`}>Pricing</a>
                      </li>
                      <li className="font-medium hover:text-purple hover:underline common-transition text-paragraph">
                        <a href={`${hashPrefix}#contact`}>Contact Us</a>
                      </li>
                    </ul>
                  </div>
                  {/* <div className="col-span-2 xl:col-span-4 md:col-span-1 mt-8 md:mt-0">
                    <div className="w-full mb-10">
                      <p className="text-main-black text-18 font-semibold mb-[30px]">
                        Stay informed
                      </p>
                      <p className="font-medium text-paragraph mb-[30px]">

                        Subscribe to 2m2x! Get the latest insights on innovation from our CEO, Rajiv Menon
                      </p>
                      <div className="mb-2.5">
                        <input
                          placeholder="Email Address"
                          className="placeholder:text-paragraph typewriter-input w-full h-[56px] bg-main-gray border border-[#e7e3fa] focus:border-purple focus:outline-none focus:right-0 rounded-full px-[25px]"
                          type="text"
                        />
                      </div>

                      <a href="#subscribe">
                        <div className="inline-flex py-3 home-two-btn-bg group bg-purple border-purple">
                          <span className="relative z-10 text-base text-white transition-all duration-300 group-hover:text-purple font-inter">
                            Subscribe
                          </span>
                          <svg
                            className="relative z-10"
                            width="7"
                            height="12"
                            viewBox="0 0 7 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              className="transition-all duration-300 group-hover:stroke-blue-seo"
                              d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                              stroke="white"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                          </svg>
                        </div>
                      </a>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            backgroundImage:
              "linear-gradient( 90deg, #2858B9 0%, #08296A 63.23%)",
          }}
          className="w-full md:h-[65px] h-10 relative"
        >
          <div className="h-full mx-auto theme-container">
            <div className="flex items-center justify-between w-full h-full text-xs md:text-base">
              <span className="text-white whitespace-nowrap">
                © 2025 Informulate, LLC. All rights reserved
              </span>
              <div className="absolute left-1/2 -translate-x-1/2 hidden md:block">
                <a
                  href="#"
                  aria-label="go top"
                  className="w-[45px] h-[45px] rounded-full border-[3px] border-white flex justify-center items-center bg-blue-sass absolute -top-[55px]"
                >
                  <span>
                    <svg
                      width="45"
                      height="45"
                      viewBox="0 0 45 45"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="22.5"
                        cy="22.5"
                        r="21"
                        fill="#08296A"
                        stroke="white"
                        strokeWidth="3"
                      />
                      <path
                        d="M19 21L23 17M23 17L27 21M23 17V29"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                </a>
              </div>
              <ul className="items-center hidden md:space-x-6 md:flex whitespace-nowrap">
                <li className="font-medium hover:text-purple hover:underline common-transition text-white">
                  <a href="https://informulate.com/privacy-policy/">Privacy Policy</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
